<template>
  <div class="row-block">
    <div class="row__name">
      <span @click="set_active(item)">{{ item.name }}</span>
    </div>
    <div class="row__date">{{ date }}</div>
    <div class="row__time">{{ time }}</div>
    <div class="row__icons">
      <span class="copy" @click="copy">
        <img src="static/images/elements/icon_copy2.svg" />
      </span>
      <span
        v-if="records.length === 0 && !past_time"
        class="go-room"
        @click="go_room"
      >
        <img src="static/images/elements/go_room.svg" />
      </span>
      <span v-else-if="is_record"
        ><img src="static/images/elements/record.svg"
      /></span>
      <span v-else-if="!is_record || past_time" class="no-record"
        ><img src="static/images/elements/record.svg"
      /></span>
    </div>
  </div>
</template>

<script>
  import Moment from 'moment';
  import CopyTextToClipboard from '@/components/mixin/CopyTextToClipboard.js';

  export default {
    name: 'history-row',

    mixins: [CopyTextToClipboard],

    props: {
      item: {
        type: Object,
        default: {}
      },
      time_format: {
        type: Number,
        default: 24
      }
    },

    data() {
      return {
        record: false
      };
    },

    computed: {
      date() {
        return this.item
          ? Moment(this.item.date_start).format(this.dateFormat)
          : null;
      },

      time() {
        if (!this.item) {
          return null;
        }

        return this.time_format === 24
          ? Moment(this.item.date_start).format('HH:mm')
          : Moment(this.item.date_start)
              .locale('en')
              .format('h:mm a')
              .toUpperCase();
      },

      past_time() {
        return this.date < Moment().format(this.dateFormat);
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      },

      records() {
        return this.item ? this.item.records : null;
      },

      comments() {
        return this.item ? this.item.comments : null;
      },

      is_record() {
        return this.records ? this.records.some(el => el.url) : false;
      },

      room_link() {
        return this.item
          ? `${window.location.origin}/online/${this.item.token}`
          : '';
      }
    },

    methods: {
      set_active(item) {
        this.$emit('set_active', item);
      },

      copy() {
        if (this.room_link) {
          this.copyLinkToClipboard(this.room_link);
        }
      },

      go_room() {
        if (this.room_link !== '') {
          window.open(this.room_link, '_blank');
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .row-block {
    display: flex;
    align-items: center;
    padding: 8px 19px;
    color: #233346;

    &:hover,
    &.active {
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      border-radius: 2px;
    }

    .row__name {
      width: 550px;

      span {
        display: inline-block;
        cursor: pointer;
      }
    }

    .row__date {
      width: 180px;
    }

    .row__time {
      width: 260px;
    }

    .row__icons {
      display: flex;
      align-items: center;
      .copy {
        display: flex;
        align-items: center;
        margin-right: 35px;
        cursor: pointer;
      }

      .go-room {
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      .no-record {
        display: flex;
        align-items: center;
        position: relative;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: -4px;
          left: 10px;
          width: 2px;
          height: 28px;
          background: #d2d6e0;
          transform: rotate(45deg);
        }
      }
    }
  }
</style>
